






































































































































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { User } from '@/data/models/user.model';
import { UserStats, UserStatsRequest } from '@/data/models/userstats.model';
import { UserService } from '@/data/services/user.service';
import { cloneDeep } from 'lodash';
import { dateEndofDay, firstDayOMonth, lastDayOfMonth } from '@/data/utils/helper';
import { plainToClass } from 'class-transformer';

import TableStatOperatore from './TableStatOperatore.vue';
import StatCallsOperatore from './StatCallsOperatore.vue';
import store, { State } from '@/store';

@Component({
	components: {
		TableStatOperatore,
		StatCallsOperatore
	},
})
export default class StatOperatore extends Vue {
	@Prop() operatore?: User;

	@Inject('UserService') userService!: UserService;

	request: UserStatsRequest = new UserStatsRequest();
	loading: boolean = false;
	dailyStats!: UserStats;
	rangeStats!: UserStats;

	state: State;

	constructor() {
		super();
		this.state = store;
		this.request.hqid = this.state.headquarter!.id; 
	}

	beforeMount() {
		if (this.operatore) {
			this.request.oid = this.operatore.id;
		}
		this.request.startdate = firstDayOMonth();
		this.request.stopdate = lastDayOfMonth();

		this.loadData();
	}

	loadData() {
		this.loading = true;

		if (this.request.stopdate) {
			this.request.stopdate = dateEndofDay(this.request.stopdate);
		}

		const dailyReq = cloneDeep(this.request);
		dailyReq.dayly = true;
		dailyReq.manageDaily();

		const requests = [
			this.operatore ? this.userService.stats(dailyReq) : this.userService.globalStats(dailyReq),
			this.operatore ? this.userService.stats(this.request) : this.userService.globalStats(this.request),
		];

		this.loading = true;
		
		Promise.all(requests)
			.then((results) => {
				this.dailyStats = plainToClass(UserStats, results[0]);
				this.rangeStats = plainToClass(UserStats, results[1]);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

}
